import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Compass } from "lucide-react";
import { Button } from "../components/ui/button";
import { applyMeta } from "../lib/pageMeta";

const LINKS = [
  { to: "/how-it-works", label: "How it works" },
  { to: "/governance-tools", label: "Free governance tools" },
  { to: "/trust-centre", label: "Trust Centre" },
  { to: "/insights", label: "Insights" },
];

export default function NotFound() {
  useEffect(() => {
    applyMeta("Page not found | norse3", "The page you were looking for doesn't exist or has moved.");
    const r = document.createElement("meta");
    r.name = "robots"; r.content = "noindex"; r.id = "nf-robots";
    document.head.appendChild(r);
    return () => document.getElementById("nf-robots")?.remove();
  }, []);

  return (
    <section className="py-24 lg:py-32" data-testid="not-found-page">
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary">Error 404</p>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground">This page has gone off the record.</h1>
        <p className="mt-5 text-base text-muted-foreground max-w-xl">The link may be out of date or the page has moved. Try one of these instead, or head back to the home page.</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="not-found-home-btn">
            <Link to="/">Back to home <ArrowRight className="ml-1.5 h-4 w-4" /></Link>
          </Button>
          <Button asChild variant="outline" data-testid="not-found-demo-btn">
            <Link to="/book-a-demo">Book a walkthrough</Link>
          </Button>
        </div>
        <ul className="mt-12 grid sm:grid-cols-2 gap-3">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="group flex items-center gap-3 rounded-lg border border-border p-4 text-sm text-foreground hover:border-primary/40 transition-colors" data-testid={`not-found-link-${l.to.slice(1)}`}>
                <Compass className="h-4 w-4 text-primary" /> {l.label}
                <ArrowRight className="ml-auto h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
